/* eslint-disable */
function find(nodes, predicate) {
  if (!nodes || !nodes.length) return null;

  const [node, ...rest] = nodes;
  if (predicate(node)) return node;

  const match = find(node.children, predicate);
  if (match) return match;

  return find(rest, predicate);
}

function filter(nodes, predicate) {
  if (!nodes || !nodes.length) return [];

  return nodes.reduce((acc, node) => {
    if (predicate(node)) {
      // eslint-disable-next-line
      acc = [...acc, {
        ...node,
        ...(node.children && { children: filter(node.children, predicate) }),
      }];
    }
    return acc;
  }, []);
}

function map(nodes, transform) {
  if (!nodes || !nodes.length) return [];

  return nodes.map((n) => ({
    ...transform(n),
    ...(n.children && { children: map(n.children, transform) }),
  }));
}

function count(nodes) {
  if (!nodes || !nodes.length) return 0;
  return nodes.reduce((total, node) => total + 1 + count(node.children), 0);
}

const rootId = Symbol('root');
function findParents(nodes, predicate) {
  const tree = {
    id: rootId,
    children: nodes,
  };

  const value = ({ children, ...props }) => props;

  const loop = (path, node) =>
    predicate(node) ?
      path :
      (node.children || []).reduce((acc, child) =>
        [...acc, ...loop([...path, value(node)], child)], []);

  return loop([], tree);
}

function findParent(nodes, predicate) {
  const ancestors = findParents(nodes, predicate);
  const parent = ancestors[ancestors.length - 1];

  return (parent && parent.id !== rootId) ? parent : null;
}

/**
 * Find all descendants of the node
 * (a descendant is either a child of the node or a child of some descendant of the node)
 *
 * @param {*} node
 * @returns flat array of all descendant nodes
 */
function findDescendants(node) {
  if (!node.children || !node.children.length) return [];

  return [
    ...node.children,
    ...node.children.flatMap(findDescendants),
  ];
}

/**
 * Flattens a tree and returns a flat list of nodes
 * @param nodes
 * @param predicate a predicate used to filter out the children of a node
 * @returns
 */
function flatten(nodes, predicate = () => true) {
  if (!nodes) return [];
  return nodes.reduce((list, node) => {
    list.push(node);
    if (predicate(node)) {
      list.push(...flatten(node.children, predicate));
    }
    return list;
  }, []);
}

// eslint-disable-next-line
export const Tree = {
  find,
  filter,
  count,
  map,
  findParent,
  findParents,
  findDescendants,
  flatten,
};
